import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class CheckCarrierAreaByPointCommand
    extends IRequestCommand<
    Boolean,
    ErrorDetails,
    ICheckCarrierAreaByPointRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.POST;

    public override setParameters(parameters: ICheckCarrierAreaByPointRequest) {
        this._commandBody = parameters;
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        this.urlSections.push('controlArea');
        this.urlSections.push(`${parameters.areaId}`);
        this.composeUrl();
    }
}

export interface ICheckCarrierAreaByPointRequest extends ICommandParameters {
    carrierId: number;
    latitude: number;
    longitude: number;
    areaId: number;
}
